import { render, staticRenderFns } from "./SettingsMeasurementRuleHeader.vue?vue&type=template&id=6bb0d784&scoped=true&lang=pug&"
import script from "./SettingsMeasurementRuleHeader.vue?vue&type=script&lang=ts&"
export * from "./SettingsMeasurementRuleHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsMeasurementRuleHeader.vue?vue&type=style&index=0&id=6bb0d784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb0d784",
  null
  
)

export default component.exports